import React from 'react';
import CheckOrCross from '../Shared/CheckOrCross';

const SLIDE_VOICEOVER_FEATURE = 'slide-voiceover';
const AI_NARRATION_FEATURE = 'ai-generate-narration';

const slideDubbingFeatures = ({ packages }) => ({
  enabled: {
    key: 'slide-dubbing-enabled',
    label: 'slideDubbing',
    values: packages.map((pkg) => (
      <CheckOrCross
        key={pkg.code}
        isCheck={!!pkg?.features?.includes(SLIDE_VOICEOVER_FEATURE)}
      />
    )),
  },
  aiPresentationScript: {
    key: 'slide-dubbing-ai-script',
    label: 'aiPresentationScript',
    values: packages.map((pkg) => (
      <CheckOrCross
        key={pkg.code}
        isCheck={!!pkg?.features?.includes(AI_NARRATION_FEATURE)}
      />
    )),
  },
});

export default slideDubbingFeatures;
